import { render } from "./BsButton.vue?vue&type=template&id=0036c8ec"
import script from "./BsButton.vue?vue&type=script&lang=js"
export * from "./BsButton.vue?vue&type=script&lang=js"
script.render = render

export default script